import { render, staticRenderFns } from "./SNCRSolicitarLoteButton.vue?vue&type=template&id=f308e0f6&"
import script from "./SNCRSolicitarLoteButton.vue?vue&type=script&lang=js&"
export * from "./SNCRSolicitarLoteButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports